import * as React from 'react';
import { useStyles } from '@sravni/react-utils';
import modules_b3384f04 from '../styles/TableView.module.less.js';

const TableView = React.forwardRef((props, ref) => {
    const { children, className, tableAttributes, ...restProps } = props;
    const { className: tableClassNames, ...restTableAttributes } = tableAttributes ?? {};
    const cx = useStyles(modules_b3384f04);
    return (React.createElement("div", { ref: ref, className: cx(className, 'container'), ...restProps },
        React.createElement("table", { className: cx(tableClassNames, 'table'), ...restTableAttributes }, children)));
});

export { TableView };
//# sourceMappingURL=TableView.js.map
